import EditHolidayGeneral from './EditHolidayGeneral';
export default EditHolidayGeneral;
